import React from 'react';

import { Badge, Callout, Step } from './shared';

const ConnectTelegram: React.FC = () => (
  <div>
    <h2 className="text-2xl font-bold mb-4">Connect Telegram</h2>
    <p className="text-sm text-base-content/70 mb-5 leading-relaxed">
      The Telegram integration lets you chat with MFlow&apos;s AI assistant directly from the Telegram app — the same AI
      that powers the in-app chat, but accessible anywhere on your phone.
    </p>

    <h3 className="font-semibold mb-3">Step-by-step</h3>
    <div className="space-y-3 mb-6">
      <Step n={1}>
        Open <strong>Integrations</strong> and locate the <strong>Telegram</strong> card.
      </Step>
      <Step n={2}>
        Click <strong>Connect Telegram</strong>. MFlow generates a <strong>one-time deep link</strong> valid for 10
        minutes and opens it in a new tab.
      </Step>
      <Step n={3}>
        The link will open Telegram (or prompt you to install it). Tap <strong>Start</strong> in the bot conversation to
        complete the pairing.
      </Step>
      <Step n={4}>
        Return to MFlow and click <strong>Done</strong>. The card updates to{' '}
        <Badge color="badge-success">Connected</Badge> showing your Telegram Chat ID and pairing date.
      </Step>
    </div>

    <Callout type="warning">
      The one-time link expires after <strong>10 minutes</strong>. If you miss the window, click <strong>Cancel</strong>{' '}
      and repeat from step 2 to generate a new link.
    </Callout>

    <h3 className="font-semibold mt-5 mb-3">Using the Telegram bot</h3>
    <p className="text-sm text-base-content/70 leading-relaxed mb-2">
      Once connected, open the MFlow bot in Telegram and type any question about your projects:
    </p>
    <ul className="text-sm text-base-content/70 space-y-1 list-disc list-inside">
      <li>&quot;What are the top risks in my projects right now?&quot;</li>
      <li>&quot;Summarize last week&apos;s delivery performance.&quot;</li>
      <li>&quot;Which tasks are overdue in Project X?&quot;</li>
    </ul>

    <h3 className="font-semibold mt-5 mb-3">Disconnecting Telegram</h3>
    <p className="text-sm text-base-content/70 leading-relaxed">
      Click <strong>Disconnect</strong> on the Telegram card. The bot pairing is removed and the bot will no longer
      respond to your messages.
    </p>
  </div>
);

export default ConnectTelegram;
